import {
  PageEnum,
  TABLEPAI,
  PASSENGER_TRAP_TABLE_HEADER,
} from "@/enums/pageEnum";
import { useTranslation } from "react-i18next";
import { HView, Status, ParentPonent } from "@/components";
import { LiftTcLongSuffix } from "@/utils/commonConfig";

export default function PassengerTrap() {
  const { t } = useTranslation();

  return (
    <ParentPonent
      tableColsRender={[
        {
          dataIndex: "liftName",
          renderText: (_: string, record: { liftId: string }) => (
            <HView
              name={_}
              path={`${PageEnum.LIFT}/detail/${record?.liftId}`}
              isNewWindow
            />
          ),
        },
        {
          dataIndex: "lmdClientId",
          renderText: (_: string, record: { lmdId: string }) => (
            <HView
              name={_}
              path={`${PageEnum.LMD}/detail/${record?.lmdId}`}
              isNewWindow
            />
          ),
        },
        {
          dataIndex: "alarmStatus",
          renderText: (_: string) => <Status status={_} />,
        },
        {
          dataIndex: "operationalStatus",
          renderText: (_: string) => <Status status={_} />,
        },
        {
          title: t("action"),
          dataIndex: "action",
          renderText: (_: string, record: { id: string }) => {
            const query = window.location.href.split("?")[1];
            return (
              <HView
                name={t("view")}
                path={`${PageEnum.ALARMPT}/detail/${record?.id}${
                  query ? `?${query}` : ""
                }`}
                state={{ callUrl: `${PageEnum.ALARMPT}${query ? `?${query}` : ""}` }}
              />
            );
          },
        },
      ]}
      filterTableFields={[
        { ...LiftTcLongSuffix(t) },
        {
          field: "alarmStatus",
          label: t("alarmStatus"),
          component: "select",
          fieldProps: { style: { width: 180 } },
          options: ["SET", "CLEAR"],
        },
        { field: "lmdClientId", label: t("lMDID"), component: "text" },
        { field: "team", label: t("team"), component: "text" },
        { field: "postalCode", label: t("postalCode"), component: "text" },
        { field: "date", label: t("setTime"), component: "timeRange" },
      ]}
      countUrl="/api/passenger/trap/count"
      tableName="passenger/trap"
      editTableHeaderUrl={PASSENGER_TRAP_TABLE_HEADER}
      requestUrl={TABLEPAI.LIFT_TRAP}
      prantPath={PageEnum.ALARMPT}
      tableTitle={t("passengerList")}
    />
  );
}
